<template>
	<div>
		<v-row v-if="cursos">
			<v-col
				cols="12"
				lg="6"
				md="6"
				sm="12"
				xs="12"
				class="d-flex flex-column"
				v-for="curso in cursos"
				:key="curso.id"
			>
				<v-hover v-slot:default="{ hover }">
					<v-card
						:elevation="hover ? 12 : 4"
						color="green darken-1"
						dark
						class="flex d-flex flex-column"
						:to="{ name: 'MeuCurso', params: { id: curso.id } }"
					>
						<v-card-title class="headline">
							<v-icon left>fal fa-chalkboard</v-icon> {{ curso.nome }}
						</v-card-title>
					</v-card>
				</v-hover>
			</v-col>
		</v-row>
		<v-alert
			color="blue-grey darken-1"
			dark
			border="right"
			icon="fas fa-empty-set"
			v-else
		>
			Sem cusros contratados
		</v-alert>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data() {
		return {
			server: 'user_data',
			cursos: [],
		}
	},
	computed: {
		...mapState(['user', 'XMLHttpRequest']),
	},
	created() {
		this.getData()
	},
	methods: {
		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_meus_cursos')
			formData.append('user_id', this.user.id)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.cursos = response.data.cursos
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},
	},
}
</script>
